import { useContext } from "react";
import { ActivosContext } from "../pages/catalogos/ActivosPage";

export const ObtenerTiposActivo = async() => {
    return new Promise((resolve, reject) => {

        const data = new FormData();
        data.append('orden','TipoInstalacion asc')
         fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=tiposInstalacion', {
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))
    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
    })
}

export const GuardarNuevoTipoActivo = (tipoActivo, idTipoInstalacion) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('tipoInstalacion', tipoActivo);
        data.append('idTipoInstalacion', idTipoInstalacion);
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=agregarTipoInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const GuardarNuevoNodo = (idNodo, nuevoIdPadre) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('idNodo', idNodo);
        data.append('idNuevoIdPadre', nuevoIdPadre);
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=cambiarNodo',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}



export const GuardarNuevoActivo = (activo) => {
    console.log('activo recibido para guardar', activo);
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('instalacion', activo.descripcion);
        data.append('siglas', activo.siglas);
        data.append('idPadre', activo.idPadre);
        if(activo?.idTipoInstalacion?.id) {
            data.append('idTipoInstalacion', activo?.idTipoInstalacion?.id );
        } else {
            data.append('idTipoInstalacion', activo.idTipoInstalacion );
        }
        if(activo?.idCapitulo?.id) {
            data.append('idCapitulo', activo?.idCapitulo?.id );
        } else {
            data.append('idCapitulo', activo.idCapitulo );
        }
        data.append('marca', activo.marca);
        data.append('modelo', activo.modelo);
        data.append('numeroInventario', activo.numeroInventario);
        data.append('serie', activo.serie);
        if(activo?.idInstalacion) {
            data.append('idInstalacion', activo.idInstalacion);

        }

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=agregarInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const EliminarTipoActivo = (idTipoActivo) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('idTipoInstalacion', idTipoActivo);
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=eliminarTipoInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ObtenerArbolActivos = () => {
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=instalacionesTree',{
            method:'POST',
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}
export const ObtenerArbolActivosAsuntos = (inicio, fin) => {
    const data = new FormData();
    data.append('inicio',inicio);
    data.append('fin',fin);
    return new Promise((resolve, reject) => {
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=instalacionesTreeAsuntos',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ObtenerDatosInstalacion = (idInstalacion) => {
    const data = new FormData();
    data.append('idInstalacion', idInstalacion);
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=datosInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ObtenerImagenesInstalacion = (idInstalacion) => {
    const data = new FormData();
    data.append('idInstalacion', idInstalacion);
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=imagenesInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const SubirImagenesInstalacion = (data) => {
    console.log('datos recibidos para subir imagenes de instalacion', data)
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=subirImagenesInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const EliminarFotoInstalacion = (foto) => {
    console.log('datos recibidos para subir imagenes de instalacion', foto)
    const data = new FormData();
    data.append('foto', foto)
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=eliminarFotoInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ValidaAsuntosInstalacion = (instalacion) => {
    console.log('datos recibidos para validar asuntos en instalaciones1', instalacion)
    const data = new FormData();
    data.append('idInstalacion', instalacion?.IdInstalacion)
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=eliminarInstalacion',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

export const ConfirmaEliminar = (instalacion) => {
    console.log('datos recibidos para validar asuntos en instalaciones1', instalacion)
    const data = new FormData();
    data.append('idInstalacion', instalacion?.IdInstalacion)
    return new Promise((resolve, reject) => {

        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=confirmaEliminar',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

